import { Trans } from "@similarweb/i18n-provider";
import { SWReactIcons, type IconName } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

type Props = {
    value: number;
    iconName: IconName;
};

export const CrmRecordsCountCell = ({ value, iconName }: Props) => {
    if (!value) {
        return null;
    }

    return (
        <Flex
            data-automation="crm-records-count-cell"
            alignItems="center"
            gap="6px"
        >
            <SWReactIcons
                size="xs"
                iconColor={colorsPalettes.carbon[300]}
                iconName={iconName}
            />
            <Text
                fontVariant="subtitle2"
                color={colorsPalettes.carbon[400]}
            >
                {value}
            </Text>

            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[300]}
            >
                <Trans
                    i18nKey="si.leads_search.crm_accounts_count_cell.record"
                    count={value}
                />
            </Text>
        </Flex>
    );
};
